module.exports = __webpack_public_path__ + "img/goal_pocket.cf890925.png";